import { useState } from 'react';
import { useDailyQuotaStore } from '@/store/daily-quota.store';

export function DailyLimitBanner() {
  const { getRemainingGenerations, checkAndResetDate } = useDailyQuotaStore();
  const [dismissed, setDismissed] = useState(false);

  // Ensure date is current
  checkAndResetDate();
  const remaining = getRemainingGenerations();

  // Only show when remaining < 2
  if (remaining >= 2 || dismissed) {
    return null;
  }

  return (
    <div className="daily-limit-banner">
      <div className="daily-limit-banner__content">
        <svg
          className="daily-limit-banner__icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        <p className="daily-limit-banner__text">
          {remaining === 0
            ? 'You have reached your daily limit for CV generations. Try again tomorrow.'
            : `You have ${remaining} CV generation${remaining === 1 ? '' : 's'} remaining today.`}
        </p>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="daily-limit-banner__close"
        aria-label="Dismiss"
      >
        <svg className="daily-limit-banner__close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
